/**
 * Calculates the modulo of the division of two given numbers.
 * Note that the modulo of the division of M and N should be a
 * number in the interval `[0, N - 1]`, thus we use this variation
 * and not the simple % operator of javascript.
 */
export function mod(dividend: number, divisor: number) {
    return ((dividend % divisor) + divisor) % divisor;
}

export function getRandomIntBetween(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export function isNumber(arg: unknown): arg is number {
    return typeof arg === 'number';
}
